export default __webpack_public_path__ + "static/media/Notpresent.84f879f8.svg";